import type { HeadingProps } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import React from "react";

const RegisterHeading = ({ children, ...props }: HeadingProps) => (
  <Heading textAlign="center" size="lg" {...props}>
    {children}
  </Heading>
);

export default RegisterHeading;
